import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { AbsencePeriod } from 'cb-model';
import { getListRowLink } from 'gossamer-unified';

export const AbsencePeriodUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(AbsencePeriod, params.key);
  const handleExit = () => navigate(getListRowLink(AbsencePeriod.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={AbsencePeriod} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/absence-period-update"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: AbsencePeriod, record },
        }}
      >
        <Update valuesKey="main" entity={AbsencePeriod} />
      </FormManager>
    </>
  );
};
